import { CssStates, embeddedImagesBase64, IGrapesJSProjectData, SmartIdentifierStates } from "../../../interfaces/VisageUI";
import { GjsAttributeNames } from "../gjsplugin/Enums";

const GjsTemplateFullPageText: IGrapesJSProjectData = {
	"assets":[

	],
	"styles":[
		{
			"selectors":[

			],
			"selectorsAdd":"body",
			"style":{
				"width":"100vw",
				"height":"100vh",
				"background-color":"transparent"
			}
		},
		{
			"selectors":[
				"gjs-plh-image"
			],
			"style":{
				"background-image":"none",
				"background-position-x":"initial",
				"background-position-y":"initial",
				"background-size":"initial",
				"background-repeat":"initial",
				"background-attachment":"initial",
				"background-origin":"initial",
				"background-clip":"initial",
				"background-color":"initial",
				"outline-color":"initial",
				"outline-style":"none",
				"outline-width":"initial"
			}
		},
		{
			"selectors":[
				"#Cf3d3d78b-3ad4-4afd-a1b7-b2fe41d9c616"
			],
			"style":{
				"width":"100%",
				"flex-direction":"column",
				"height":"100%",
				"display":"flex",
				"justify-content":"center",
				"align-items":"center",
				"align-content":"center"
			}
		},
		{
			"selectors":[
				"Btn_SecondaryCTA"
			],
			"style":{
				"__background-type":"grad",
				"background-repeat":"repeat",
				"background-position":"left top",
				"background-attachment":"scroll",
				"background-size":"auto",
				"background-image":"linear-gradient(to top, #b4b4b4 86%, #d5d5d5 100%)",
				"position":"relative",
				"margin":"0vw 0.5vw 0vw 0vw",
				"width":"20vw"
			}
		},
		{
			"selectors":[
				"Btn_Primary_CTA"
			],
			"style":{
				"position":"relative",
				"width":"20vw"
			}
		},
		{
			"selectors":[
				{
					"name":"Btn_SecondaryTest",
					"active":false
				}
			],
			"style":{
				"width":"20vw",
				"border":"0vw none black"
			}
		},
		{
			"selectors":[
				"#C4aa2cd52-ef5b-4ab4-8834-3d51621305c3-23"
			],
			"style":{
				"height":"4.5vw",
				"font-size":"2vw",
				"box-shadow":"0vw 0vw 0.75vw 0vw rgba(0,0,0,0.51) ",
				"border-radius":"20vw 20vw 20vw 20vw",
				"__background-type":"grad",
				"background-repeat":"repeat",
				"background-position":"left top",
				"background-attachment":"scroll",
				"background-size":"auto",
				"background-image":"linear-gradient(to top, #3d3d3d 0%, #6c6c6c 100%)",
				"color":"#ebebeb",
				"border":"0vw none black",
				"align-self":"center",
				"min-height":"4.5vw",
				"font-weight":"700",
				"width":"20vw",
				"margin":"0 2vw 0 0"
			}
		},
		{
			"selectors":[
				"#C0df669d1-6c9d-4ed3-a74b-fe9f5f083d58"
			],
			"style":{
				"width":"70vw",
				"background":"rgba(30,30,30,0.8)",
				"flex-direction":"column",
				"box-shadow":"0vw 0vw 2vw 0vw rgba(30, 30, 30, 1) ",
				"display":"flex",
				"padding-top":"2vw",
				"padding-right":"2vw",
				"padding-bottom":"2vw",
				"padding-left":"2vw",
				"border-top-left-radius":"2vw",
				"border-top-right-radius":"2vw",
				"border-bottom-right-radius":"2vw",
				"border-bottom-left-radius":"2vw",
				"min-height":"40vw"
			}
		},
		{
			"selectors":[
				"#C8e22a94e-20db-4d49-a07f-fcd0091b2fce-2"
			],
			"style":{
				"white-space-collapse":"preserve",
				"font-size":"2vw",
				"font-family":"Arial, Helvetica, sans-serif",
				"color":"#ebebeb",
				"height":"100%",
				"overflow-y":"auto",
				"width":"100%",
				"margin-top":"1vw",
				"margin-bottom":"0vw",
				"margin-left":"0vw",
				"margin-right":"0vw"
			}
		},
		{
			"selectors":[
				"#C3e755fac-11bf-4d92-973e-03e5605f4e57"
			],
			"style":{
				"height":"4.5vw",
				"font-size":"2vw",
				"box-shadow":"0vw 0vw 0.75vw 0vw rgba(0,0,0,0.51) ",
				"border-radius":"20vw 20vw 20vw 20vw",
				"__background-type":"grad",
				"background-repeat":"repeat",
				"background-position":"left top",
				"background-attachment":"scroll",
				"background-size":"auto",
				"background-image":"linear-gradient(to top, #c5c5c5 0%, #fbfbfb 100%)",
				"color":"#303030",
				"border":"0vw none black",
				"align-self":"center",
				"min-height":"4.5vw",
				"font-weight":"700",
				"width":"20vw"
			}
		},
		{
			"selectors":[
				"#Ce8bd14e9-7db3-44dc-b089-1f8205515070-2"
			],
			"style":{
				"white-space-collapse":"preserve",
				"font-size":"3vw",
				"color":"#ebebeb",
				"font-family":"Arial, Helvetica, sans-serif",
				"font-weight":"700",
				"width":"100%"
			}
		},
		{
			"selectors":[
				"#C4aa2cd52-ef5b-4ab4-8834-3d51621305c3-23"
			],
			"style":{
				"border":"0 none black"
			},
			"state":CssStates.Active
		},
		{
			"selectors":[
				"#C3e755fac-11bf-4d92-973e-03e5605f4e57"
			],
			"style":{
				"border":"0 none black"
			},
			"state":CssStates.Active
		},
		{
			"selectors":[
				"#C4aa2cd52-ef5b-4ab4-8834-3d51621305c3-23"
			],
			"style":{
				"border":"0 none black"
			},
			"state":CssStates.Hover
		},
		{
			"selectors":[
				"#C3e755fac-11bf-4d92-973e-03e5605f4e57"
			],
			"style":{
				"border":"0 none black"
			},
			"state":CssStates.Hover
		},
		{
			"selectors":[

			],
			"selectorsAdd":"*",
			"style":{
				"font-family":"Roboto, Arial, sans-serif"
			}
		},
		{
			"selectors":[

			],
			"selectorsAdd":"::-webkit-scrollbar",
			"style":{
				"width":"10px",
				"height":"10px"
			}
		},
		{
			"selectors":[

			],
			"selectorsAdd":"::-webkit-scrollbar-track",
			"style":{
				"background-color":"rgb(51, 51, 51)"
			}
		},
		{
			"selectors":[

			],
			"selectorsAdd":"::-webkit-scrollbar-corner",
			"style":{
				"background-color":"rgb(51, 51, 51)"
			}
		},
		{
			"selectors":[

			],
			"selectorsAdd":"::-webkit-scrollbar-thumb",
			"style":{
				"background-color":"rgb(191, 191, 191)"
			}
		},
		{
			"selectors":[

			],
			"selectorsAdd":"::-webkit-scrollbar-thumb:hover",
			"style":{
				"background-color":"rgb(235, 235, 235)"
			}
		},
		{
			"selectors":[
				"primary-cta"
			],
			"style":{
				"display":"flex",
				"align-items":"center",
				"justify-content":"center",
				"width":"20vw",
				"height":"4.5vw",
				"min-height":"4.5vw",
				"border-top-left-radius":"12vw",
				"border-top-right-radius":"12vw",
				"border-bottom-right-radius":"12vw",
				"border-bottom-left-radius":"12vw",
				"background-image":"linear-gradient(rgb(255, 255, 255) 0%, rgb(239, 239, 239) 100%)",
				"background-position-x":"initial",
				"background-position-y":"initial",
				"background-size":"initial",
				"background-repeat":"initial",
				"background-attachment":"initial",
				"background-origin":"initial",
				"background-clip":"initial",
				"background-color":"initial",
				"color":"rgb(48, 48, 48)",
				"font-size":"2vw",
				"box-shadow":"rgba(0, 0, 0, 0.4) 0px 0px 1vw 0px"
			}
		},
		{
			"selectors":[
				"primary-cta"
			],
			"style":{
				"transform":"scale(1.05, 1.05)"
			},
			"state":CssStates.Hover
		},
		{
			"selectors":[
				"primary-cta"
			],
			"style":{
				"background-image":"linear-gradient(rgb(255, 255, 255) 0%, rgb(239, 239, 239) 100%)",
				"background-position-x":"initial",
				"background-position-y":"initial",
				"background-size":"initial",
				"background-repeat":"initial",
				"background-attachment":"initial",
				"background-origin":"initial",
				"background-clip":"initial",
				"background-color":"initial"
			},
			"state":CssStates.Active
		},
		{
			"selectors":[
				"secondary-cta"
			],
			"style":{
				"display":"flex",
				"align-items":"center",
				"justify-content":"center",
				"width":"20vw",
				"height":"4.5vw",
				"min-height":"4.5vw",
				"border-top-left-radius":"12vw",
				"border-top-right-radius":"12vw",
				"border-bottom-right-radius":"12vw",
				"border-bottom-left-radius":"12vw",
				"background-image":"linear-gradient(rgb(118, 118, 118) 0%, rgb(79, 79, 79) 100%)",
				"background-position-x":"initial",
				"background-position-y":"initial",
				"background-size":"initial",
				"background-repeat":"initial",
				"background-attachment":"initial",
				"background-origin":"initial",
				"background-clip":"initial",
				"background-color":"initial",
				"color":"rgb(235, 235, 235)",
				"font-size":"2vw",
				"box-shadow":"rgba(0, 0, 0, 0.4) 0px 0px 1vw 0px"
			}
		},
		{
			"selectors":[
				"secondary-cta"
			],
			"style":{
				"transform":"scale(1.05, 1.05)"
			},
			"state":CssStates.Hover
		},
		{
			"selectors":[
				"secondary-cta"
			],
			"style":{
				"background-image":"linear-gradient(rgb(164, 164, 164) 0%, rgb(126, 126, 126) 100%)",
				"background-position-x":"initial",
				"background-position-y":"initial",
				"background-size":"initial",
				"background-repeat":"initial",
				"background-attachment":"initial",
				"background-origin":"initial",
				"background-clip":"initial",
				"background-color":"initial"
			},
			"state":CssStates.Active
		},
		{
			"selectors":[
				"primary-icon-cta"
			],
			"style":{
				"display":"flex",
				"align-items":"center",
				"justify-content":"center",
				"width":"9vw",
				"height":"9vw",
				"background-color":"rgba(30, 30, 30, 0.8)",
				"border-top-left-radius":"50%",
				"border-top-right-radius":"50%",
				"border-bottom-right-radius":"50%",
				"border-bottom-left-radius":"50%"
			}
		},
		{
			"selectors":[
				"primary-icon-cta"
			],
			"style":{
				"transform":"scale(1.05, 1.05)"
			},
			"state":CssStates.Hover
		},
		{
			"selectors":[
				"primary-icon-cta"
			],
			"style":{
				"background-color":"rgb(89, 89, 89)"
			},
			"state":CssStates.Active
		},
		{
			"selectors":[
				"secondary-icon-cta"
			],
			"style":{
				"display":"flex",
				"align-items":"center",
				"justify-content":"center",
				"width":"7.25vw",
				"height":"7.25vw",
				"background-color":"rgba(30, 30, 30, 0.8)",
				"border-top-left-radius":"50%",
				"border-top-right-radius":"50%",
				"border-bottom-right-radius":"50%",
				"border-bottom-left-radius":"50%"
			}
		},
		{
			"selectors":[
				"secondary-icon-cta"
			],
			"style":{
				"transform":"scale(1.05, 1.05)"
			},
			"state":CssStates.Hover
		},
		{
			"selectors":[
				"secondary-icon-cta"
			],
			"style":{
				"background-color":"rgb(89, 89, 89)"
			},
			"state":CssStates.Active
		},
		{
			"selectors":[

			],
			"selectorsAdd":"div[data-gjs-type=\"wrapper\"]",
			"style":{
				"height":"100vh",
				"width":"100vw"
			}
		},
		{
			"selectors":[

			],
			"selectorsAdd":"text",
			"style":{
				"display":"inline-block",
				"min-width":"1vw",
				"min-height":"1vw"
			}
		},
		{
			"selectors":[
				"visageEditorDefaultContainer"
			],
			"style":{
				"position":"relative",
				"width":"100%",
				"height":"100%",
				"display":"flex",
				"align-items":"center",
				"justify-content":"center"
			}
		},
		{
			"selectors":[
				"#C8081d36f-417d-447a-b625-7fd96c9725ef"
			],
			"style":{
				"position":"absolute",
				"right":"1.5vw",
				"top":"calc(50% + 0vw)",
				"transform":"translateY(-50%)",
				"display":"flex",
				"align-items":"center",
				"flex-direction":"column",
				"justify-content":"center"
			}
		},
		{
			"selectors":[
				"#C08bd4888-930e-4921-bc35-47acc297a72a"
			],
			"style":{
				"position":"relative",
				"background":"rgba(30, 30, 30, 0.9)",
				"border-top-left-radius":"4.5vw",
				"border-top-right-radius":"4.5vw",
				"border-bottom-right-radius":"4.5vw",
				"border-bottom-left-radius":"4.5vw",
				"width":"9vw",
				"height":"9vw",
				"padding-left":"0.5vw",
				"margin-top":"0vw",
				"margin-bottom":"1vw",
				"margin-left":"0vw",
				"margin-right":"0vw",
				"padding-top":"1.5vw",
				"padding-bottom":"1.5vw"
			}
		},
		{
			"selectors":[
				"#C407ae98d-9f49-4fa6-80da-8684ed4bb2a1"
			],
			"style":{
				"height":"100%"
			}
		},
		{
			"selectors":[
				"#C3fd522fb-6b28-4790-9f88-8382dfc72918"
			],
			"style":{
				"position":"relative",
				"background":"rgba(30, 30, 30, 0.9)",
				"border-top-left-radius":"3.625vw",
				"border-top-right-radius":"3.625vw",
				"border-bottom-right-radius":"3.625vw",
				"border-bottom-left-radius":"3.625vw",
				"width":"7.25vw",
				"height":"7.25vw",
				"padding-right":"0.5vw",
				"padding-top":"1.25vw",
				"padding-bottom":"1.25vw"
			}
		},
		{
			"selectors":[
				"#C6373c9df-a84e-47ec-b22b-e7c2ab2e2b66"
			],
			"style":{
				"height":"100%"
			}
		},
		{
			"selectors":[
				"#Cd49b39a2-e57e-48fc-9be0-763176432440"
			],
			"style":{
				"position":"absolute",
				"bottom":"2vw",
				"left":"2vw",
				"background":"rgba(30, 30, 30, 0.9)",
				"border-top-left-radius":"3.625vw",
				"border-top-right-radius":"3.625vw",
				"border-bottom-right-radius":"3.625vw",
				"border-bottom-left-radius":"3.625vw",
				"display":"flex",
				"padding-bottom":"0.5vw"
			}
		},
		{
			"selectors":[
				"#C159f0d5f-a678-4a0a-b84e-c6570393ff95"
			],
			"style":{
				"width":"70%",
				"height":"70%"
			}
		},
		{
			"selectors":[
				"#C68c019b9-42ae-4634-9c9d-ade6930c9551"
			],
			"style":{
				"display":"none",
				"flex-direction":"row",
				"justify-content":"flex-end",
				"margin-top":"1vw",
				"margin-bottom":"0",
				"margin-left":"0",
				"margin-right":"0",
				"align-items":"center"
			}
		},
		{
			"selectors":[
				"#C969f585a-c359-4e45-9580-25fb6424545c"
			],
			"style":{
				"display":"flex",
				"align-items":"center",
				"justify-content":"center",
				"width":"20vw",
				"height":"4.5vw",
				"min-height":"4.5vw",
				"border-top-left-radius":"12vw",
				"border-top-right-radius":"12vw",
				"border-bottom-right-radius":"12vw",
				"border-bottom-left-radius":"12vw",
				"background-image":"linear-gradient(rgb(118, 118, 118) 0%, rgb(79, 79, 79) 100%)",
				"background-position-x":"initial",
				"background-position-y":"initial",
				"background-size":"initial",
				"background-repeat":"initial",
				"background-attachment":"initial",
				"background-origin":"initial",
				"background-clip":"initial",
				"background-color":"initial",
				"color":"rgb(235, 235, 235)",
				"font-size":"2vw",
				"box-shadow":"rgba(0, 0, 0, 0.4) 0px 0px 1vw 0px",
				"background":"linear-gradient(0deg, RGB(70, 70, 70) 0%, rgba(102,102,102,1) 100%)",
				"margin-top":"0vw",
				"margin-bottom":"0vw",
				"margin-left":"0vw",
				"margin-right":"1vw"
			}
		},
		{
			"selectors":[
				"#C7fe5dbed-f30e-44dc-a5e9-b2dd95182c7a"
			],
			"style":{
				"font-size":"2vw",
				"font-weight":"700",
				"color":"rgba(235, 235, 235, 1)"
			}
		},
		{
			"selectors":[
				"#C55568213-54ca-41e0-9c13-1b61dcb7b343"
			],
			"style":{
				"display":"flex",
				"align-items":"center",
				"justify-content":"center",
				"width":"20vw",
				"height":"4.5vw",
				"min-height":"4.5vw",
				"border-top-left-radius":"12vw",
				"border-top-right-radius":"12vw",
				"border-bottom-right-radius":"12vw",
				"border-bottom-left-radius":"12vw",
				"background-image":"linear-gradient(rgb(255, 255, 255) 0%, rgb(239, 239, 239) 100%)",
				"background-position-x":"initial",
				"background-position-y":"initial",
				"background-size":"initial",
				"background-repeat":"initial",
				"background-attachment":"initial",
				"background-origin":"initial",
				"background-clip":"initial",
				"background-color":"initial",
				"color":"rgb(48, 48, 48)",
				"font-size":"2vw",
				"box-shadow":"rgba(0, 0, 0, 0.4) 0px 0px 1vw 0px",
				"background":"linear-gradient(0deg, RGB(197, 197, 197) 0%, rgba(241,241,241,1) 100%)",
				"margin-top":"0vw",
				"margin-bottom":"0vw",
				"margin-left":"1vw",
				"margin-right":"0vw"
			}
		},
		{
			"selectors":[
				"#C3fd14c4b-5d38-47ee-9b5c-e4bbe06b8887"
			],
			"style":{
				"font-size":"2vw",
				"font-weight":"700",
				"color":"rgba(48, 48, 48, 1)"
			}
		}
	],
	"pages":[
		{
			"frames":[
				{
					"component":{
						"type":"wrapper",
						"stylable":[
							"background",
							"background",
							"background-image",
							"background-repeat",
							"background-attachment",
							"background-position",
							"background-size"
						],
						"attributes":{
							"id":"i5rl"
						},
						"components":[
							{
								"type":"div",
								"attributes":{
									"id":"Cf3d3d78b-3ad4-4afd-a1b7-b2fe41d9c616",
									"data-action":"",
									"data-no-actions":"",
									"data-not-deletable":"",
									"data-not-resizable":"",
									"data-not-copiable":""
								},
								"components":[
									{
										"type":"div",
										"attributes":{
											"id":"C0df669d1-6c9d-4ed3-a74b-fe9f5f083d58",
											"data-action":""
										},
										"components":[
											{
												"type":"e-text",
												"content":"Title",
												"attributes":{
													"id":"Ce8bd14e9-7db3-44dc-b089-1f8205515070-2",
													"data-action":""
												},
												"custom-name":"Title"
											},
											{
												"type":"e-text",
												"content":"Description",
												"attributes":{
													"id":"C8e22a94e-20db-4d49-a07f-fcd0091b2fce-2",
													"data-action":"",
													[GjsAttributeNames.SmartIdentifier]:SmartIdentifierStates.Enabled,
												},
												"custom-name":"Description"
											},
											{
												"type":"div",
												"attributes":{
													"id":"C68c019b9-42ae-4634-9c9d-ade6930c9551",
													"data-action":""
												},
												"components":[
													{
														"type":"div",
														"name":"Secondary Button",
														"classes":[
															"secondary-cta"
														],
														"attributes":{
															"id":"C969f585a-c359-4e45-9580-25fb6424545c",
															"asset-id":""
														},
														"components":[
															{
																"type":"e-text",
																"name":"Label",
																"content":"Cancel",
																"attributes":{
																	"id":"C7fe5dbed-f30e-44dc-a5e9-b2dd95182c7a",
																}
															}
														]
													},
													{
														"type":"div",
														"name":"Primary Button",
														"classes":[
															"primary-cta"
														],
														"attributes":{
															"id":"C55568213-54ca-41e0-9c13-1b61dcb7b343",
															"asset-id":""
														},
														"components":[
															{
																"type":"e-text",
																"name":"Label",
																"content":"Accept",
																"attributes":{
																	"id":"C3fd14c4b-5d38-47ee-9b5c-e4bbe06b8887",
																}
															}
														]
													}
												],
												"custom-name":"Buttons",
												"__prev-display":"flex"
											}
										],
										"custom-name":"Dialog UI"
									},
									{
										"type":"div",
										"attributes":{
											"id":"C8081d36f-417d-447a-b625-7fd96c9725ef",
											"data-action":""
										},
										"components":[
											{
												"type":"div",
												"name":"Next Button",
												"classes":[
													"primary-icon-cta"
												],
												"attributes":{
													"id":"C08bd4888-930e-4921-bc35-47acc297a72a",
													"data-action":"next_step"
												},
												"components":[
													{
														"type":"image",
														"name":"Icon",
														"resizable":{
															"ratioDefault":1
														},
														"attributes":{
															"id":"C407ae98d-9f49-4fa6-80da-8684ed4bb2a1",
															"asset-id":"",
															"src":embeddedImagesBase64.next,
														}
													}
												]
											},
											{
												"type":"div",
												"name":"Previous Button",
												"classes":[
													"secondary-icon-cta"
												],
												"attributes":{
													"id":"C3fd522fb-6b28-4790-9f88-8382dfc72918",
													"data-action":"previous_step"
												},
												"components":[
													{
														"type":"image",
														"name":"Icon",
														"resizable":{
															"ratioDefault":1
														},
														"attributes":{
															"id":"C6373c9df-a84e-47ec-b22b-e7c2ab2e2b66",
															"asset-id":"",
															"src":embeddedImagesBase64.prev,
														}
													}
												]
											}
										],
										"custom-name":"Prev/Next Buttons",
										"__prev-display":"flex"
									},
									{
										"type":"div",
										"name":"Home Button",
										"classes":[
											"secondary-icon-cta"
										],
										"attributes":{
											"id":"Cd49b39a2-e57e-48fc-9be0-763176432440",
											"data-action":""
										},
										"components":[
											{
												"type":"image",
												"name":"Icon",
												"resizable":{
													"ratioDefault":1
												},
												"attributes":{
													"id":"C159f0d5f-a678-4a0a-b84e-c6570393ff95",
													"asset-id":"",
													"src":embeddedImagesBase64.home,
													"data-action":""
												}
											}
										]
									}
								],
								"custom-name":"Template Container"
							}
						],
						"custom-name":"Full Page Text"
					},
					"id":"DWjqyp3eM1mnUsvJ"
				}
			],
			"type":"main",
			"id":"kOCGgDvnkDAuSz8T"
		}
	]
};

export default GjsTemplateFullPageText;